export default __webpack_public_path__ + "static/media/ABBvoice_W_Md.fc580fd5.woff";